export default function Input({ placeholder, classes, ...rest }) {

    return (

        <input placeholder={placeholder} className={`${classes || ""} p-3 w-[250px] reletive z-0 sm:min-w-[350px] rounded-[7px] mt-5  outline-none`} {...rest} />

    )
}
